import { ResultSet } from "@cubejs-client/core";
import { DateTime } from "luxon";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
import { getDateDimensionNames } from "./customDate";

export const loadCostReferenceDate = (useCustomCalendar: boolean): AppThunk<Promise<DateTime>> => async (dispatch) => {
    try {
        const { maxMonthPeriodStartDate, maxMonthPeriodEndDate } = getDateDimensionNames(useCustomCalendar);

        const costsQuery = {
            dimensions: [
                "CostReferenceDate.MaxDate",
                `CostReferenceDate.${maxMonthPeriodEndDate}`
            ]
        };

        const salesQuery = {
            dimensions: [
                "SalesReferenceDate.MaxDate",
                `SalesReferenceDate.${maxMonthPeriodStartDate}`,
                `SalesReferenceDate.${maxMonthPeriodEndDate}`
            ]
        };

        const costPromise = dispatch(cubeLoad(costsQuery));
        const salesPromise = dispatch(cubeLoad(salesQuery));

        const costsResultSet = await costPromise as unknown as ResultSet;
        const salesResultSet = await salesPromise as unknown as ResultSet;
        const costsRawData = costsResultSet.rawData();
        const salesRawData = salesResultSet.rawData();
        const salesLatestDate = DateTime.fromISO(salesRawData[0]["SalesReferenceDate.MaxDate"], { zone: "utc" });
        const salesStartOfPeriod = DateTime.fromISO(salesRawData[0][`SalesReferenceDate.${maxMonthPeriodStartDate}`], { zone: "utc" });
        const salesEndOfPeriod = DateTime.fromISO(salesRawData[0][`SalesReferenceDate.${maxMonthPeriodEndDate}`], { zone: "utc" });

        const salesEndOfLastFullPeriod: DateTime = salesLatestDate.equals(salesEndOfPeriod)
            ? salesEndOfPeriod
            : salesStartOfPeriod.minus({ days: 1 }).endOf("day");

        const costEndOfPeriod: DateTime = costsRawData.length !== 0 ?
            DateTime.fromISO(costsRawData[0][`CostReferenceDate.${maxMonthPeriodEndDate}`], { zone: "utc" }) :
            salesEndOfLastFullPeriod;

        const overallReferenceDate = costEndOfPeriod < salesEndOfLastFullPeriod ? costEndOfPeriod : salesEndOfLastFullPeriod;
        return overallReferenceDate;
    } catch (error) {
        dispatch(logError("Error loading CostReferenceDate.", error));
        throw error;
    }
};
